export const blockContextMenuInAntdPreview = () => {
  const previewModal = document.querySelector(
    ".ant-image-preview-img",
  ) as HTMLImageElement;

  if (previewModal) {
    previewModal.oncontextmenu = (e) => e.preventDefault(); // 우클릭 방지
  }
};
